<template>
  <div class="map-chart" v-loading="loading">
    <div :id="id" style="width: 100%; height:100%;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import china from '../china.json'
import moment from 'moment/moment'
import _ from 'lodash'
// import { Exporter as ExcelExporter } from '@/libs/excelfile'
import { LoadBrandStatisticByArea, CostumerConsumer } from '../services'
export default {
  data () {
    return {
      loading: true,
      data: []
    }
  },
  props: {
    timeSpan: {
      type: Array,
      default () {
        return null
      }
    },
    id: {
      type: String,
      default () {
        return 'map_cn'
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.$on('exportExcel', () => {
        this.doExpMonth()
      })
    })
  },
  async created () {
    await this.loadData()
    this.loadDataDebounce = _.debounce(() => {
      this.loadData()
    }, 30)
  },
  computed: {
    startDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[0]).format('YYYY-MM-DD')
      }
      return undefined
    },
    endDay () {
      if (this.timeSpan) {
        return moment(this.timeSpan[1]).format('YYYY-MM-DD')
      }
      return undefined
    }
  },
  watch: {
    startDay () {
      this.loadDataDebounce()
    },
    endDay () {
      this.loadDataDebounce()
    },
    newAdd () {
      this.loadDataDebounce()
    },
    area () {
      this.loadDataDebounce()
    }
  },
  methods: {
    doExpMonth () {
      this.loading = true
      const brandDatas = this.expData()
      CostumerConsumer({ newAdd: this.newAdd, area: this.area || undefined, startDay: this.startDay, endDay: this.endDay }, brandDatas).catch((ex) => {
        this.$message.error(ex.message)
      }).finally(() => {
        this.loading = false
      })
    },
    expData () {
      const mergeInfo = []
      const options = {
        '!cols': [
          { wpx: 60 },
          { wpx: 60 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 },
          { wpx: 100 },
          { wpx: 80 }
        ]
      }
      const exportData = []
      exportData.push(
        ['地区', '品牌', '销售', '订单笔数', '退款', '退款笔数', '急件', '急件笔数', '急件退', '急件退款笔数', '含税', '含税笔数', '含税退', '含税退款笔数']
      )
      this.data.forEach(t => {
        t.showValue.forEach(p => {
          exportData.push(
            [
              t.name, // 地区
              p.name, // 品牌
              p.amount, // 销售
              p.orderCount, // 订单笔数
              p.amountReturn, // 退款
              p.orderReturnCount, // 退款笔数
              p.amountJi, // 急件
              p.orderCountJi, // 急件笔数
              p.amountReturnJi, // 急件退
              p.orderReturnCountJi, // 急件退款笔数
              p.amountTax, // 含税
              p.orderCountTax, // 含税笔数
              p.amountReturnTax, // 含税退
              p.orderReturnCountTax // 含税退笔数
            ]
          )
        })
      })
      return {
        data: exportData,
        mergeInfo,
        sheetName: '区域品牌销售统计',
        options
      }
    },
    loadData () {
      this.loading = true
      LoadBrandStatisticByArea({ newAdd: this.newAdd, startDay: this.startDay, endDay: this.endDay, area: this.area || undefined }).then(resp => {
        this.data = resp
        this.init()
      }).finally(() => {
        this.loading = false
      })
    },
    init () {
      let dom = document.getElementById(this.id)
      const maxAmount = Math.ceil((_.maxBy(this.data, o => o.value).value) / 100000) * 100000
      if (dom) {
        let myEchart = echarts.init(dom)
        echarts.registerMap('中国', china)
        let option = {
          dataZoom: {
            type: 'inside'
          },
          visualMap: {
            left: 'right',
            min: 0,
            max: Math.round(maxAmount * 1.1),
            inRange: {
              color: [
                '#313695',
                '#4575b4',
                '#74add1',
                '#abd9e9',
                '#e0f3f8',
                '#ffffbf',
                '#fee090',
                '#fdae61',
                '#f46d43',
                '#d73027',
                '#a50026'
              ]
            },
            text: ['高', '低'],
            calculable: true
          },
          tooltip: {
            trigger: 'item',
            className: 'map-chart-tooltip',
            showDelay: 0,
            transitionDuration: 0.2,
            formatter (params) {
              let rowHtml = ''
              let totalReturnAmount = 0
              let totalAmount = 0
              if (params.data && params.data.showValue) {
                params.data.showValue.forEach(e => {
                  totalAmount += e.amount
                  totalReturnAmount += e.amountReturn
                  rowHtml += `
                  <div class="serie-item">
                    <div>
                    </div>
                    <div>
                    ${e.name}
                    </div>
                    <div>
                      ${e.amount.toFixed(2)} (${e.orderCount}笔)
                    </div>
                    <div>
                      ${e.amountReturn.toFixed(2)} (${e.orderReturnCount}笔)
                    </div>
                    <div>${(e.amount - e.amountReturn).toFixed(2)}</div>
                  </div>
                  `
                })
              }
              const totalRemainAmount = totalAmount - totalReturnAmount
              if (params.data && params.data.showValue) {
                return `
                  <div class="map-chart-tooltip">
                    <div class="date">${params.name}</div>
                    <div class="serie-item top">
                      <div></div>
                      <div>品牌</div>
                      <div>销售</div>
                      <div>退款</div>
                      <div>小计</div>
                    </div>
                    ${rowHtml}
                    <div class="serie-item total">
                      <div></div>
                      <div>合计：</div>
                      <div>${totalAmount.toFixed(2)}</div>
                      <div>${totalReturnAmount.toFixed(2)}</div>
                      <div>${totalRemainAmount.toFixed(2)}</div>
                    </div>
                  </div>`
              } else {
                return `
<div>
  <div class="date">${params.name}</div>
  </div>
      `
              }
            }
          },
          series: [{
            zoom: 1.6,
            top: this.id === 'zoom-map' ? 170 : 85,
            name: '中国',
            type: 'map',
            map: '中国', // 自定义扩展图表类型
            // roam: true, // 是否开启平游或缩放
            // scaleLimit: { // 滚轮缩放的极限控制
            //   min: 1,
            //   max: 2
            // },
            showLegendSymbol: true, // 存在legend时显示
            // label: { // 文字
            //   show: true,
            //   color: '#fff',
            //   fontSize: 10
            // },
            itemStyle: { // 地图样式
              areaColor: '#B1B2B2',
              borderColor: '#ffffff',
              borderWidth: 1
            },
            legend: {
              orient: 'vertical',
              top: 'middle'
            },
            emphasis: { // 鼠标移入时显示的默认样式
              itemStyle: {
                areaColor: '#f6dc7d',
                borderColor: '#404a59',
                borderWidth: 1
              },
              label: { // 文字
                show: true,
                color: '#333333',
                fontSize: 12,
                fontWeight: 600
              }
            },
            data: this.data
          }]
        }
        myEchart.setOption(option)
        window.addEventListener('resize', () => {
          myEchart.resize()
        })
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.map-chart
  width 100% !important
  height 100%
  #map_cn, #zoom-map
    width 100%
    height 100%
    div
      width 100%
      height 100% !important
      canvas
        width 100%
        height 100% !important
</style>
